// extracted by mini-css-extract-plugin
export var avatar = "_n2-3";
export var avatarContainer = "_n2-2";
export var avatarSpacer = "_n2-5";
export var avatarSpacerContainer = "_n2-4";
export var avatarStackContainer = "_n2-1";
export var bubble = "_n2-0";
export var remainderBubble = "_n2-6";